/** Synthetic pagination cursor for API-backed lists (replaces Firestore DocumentSnapshot). */
export interface ApiListCursor {
  __apiOffset: number;
}

export function createApiListCursor(offset: number): ApiListCursor {
  return { __apiOffset: offset };
}

export function getApiListOffset(
  cursor: unknown,
  fallback: number = 0
): number {
  if (
    cursor &&
    typeof cursor === 'object' &&
    '__apiOffset' in cursor &&
    typeof (cursor as ApiListCursor).__apiOffset === 'number'
  ) {
    return (cursor as ApiListCursor).__apiOffset;
  }
  return fallback;
}
